export default window._cmsContent['solar/faq']